import React, {useState ,useEffect ,useCallback} from 'react';
import Toast from "../../Components/Toast";
import Header from "../../Layouts/Header";

import { MapContainer, Marker, TileLayer, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import MapMarker from "../../Assets/Images/mapMarker.png";
import {TbBrandGoogleMaps, TbCheck} from "react-icons/tb";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import Loading from "../../Layouts/Loading";

let DefaultIcon = L.icon({
    iconUrl: MapMarker,
    iconSize: [16,16],
});

L.Marker.prototype.options.icon = DefaultIcon;

const center = [36.32,59.51]
const zoom = 13

function AddAddress(props) {
    const navigate = useNavigate();

    const [haveLocation, setHaveLocation] = React.useState(true);
    const [map, setMap] = React.useState(null);
    const [address, setAddress] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [position, setPosition] = useState(map?map.getCenter() : {lat:0 , lng: 0})
    const [isLoaded, setIsLoaded] = React.useState(true);

    const onSaveAddress = () => {
        const request = {
            title,
            address,
            contact_phone: phone,
            lat : position.lat.toFixed(4),
            long : position.lng.toFixed(4),


        }
        setIsLoaded(false)
        setHaveLocation(false)
        API.storeAddress(request)
            .then((response) => {

                toast.success(response.message);

                setTimeout (() => {
                    navigate('/request-options');
                },1500)
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    const onMove = useCallback(() => {
        setPosition(map.getCenter())
    }, [map])

    useEffect(() => {
        if(map )
            map.on('move', onMove)
        return () => {
            if(map )
                map.off('move', onMove)
        }
    }, [map, onMove])


    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='افزودن آدرس' hasBack={true} />
            {
                haveLocation &&
                <section className="container-fluid modal-bg max-w-lg">
                    <div className="row rtl overflow-scroll vh-100  mb-5">


                        <div className="col-12 form-floating mt-3">
                                                <textarea className="form-control"
                                                          placeholder="توضیحات"
                                                          id="floatingTextarea"
                                                          rows={8}
                                                          value={address}
                                                          onChange={(val) => {
                                                              setAddress(val.target.value)
                                                          }}
                                                >
                            </textarea>
                            <label htmlFor="floatingTextarea" className='text-small-2'>
                                آدرس دقیق
                            </label>
                        </div>
                        {
                            position.lng > 0  ?
                                <div className="col-12 text-center mt-2">
                                    <img src={`https://api.neshan.org/v2/static?key=service.9ae05bedd2e94c62bf674e9f57dceb30&type=dreamy&zoom=18&center=${position.lat.toFixed(4)},${position.lng.toFixed(4)}&width=200&height=50&marker=red`}
                                         className='neshan-map max-w-lg ' alt='نمایش موقعیت انتخابی'
                                    />
                                    <button className=' btn btn-warning text-small-1 fw-bold px-5 mt-3'
                                            onClick={() => setHaveLocation(false)}

                                    >
                                        <TbBrandGoogleMaps className='ms-2 text-big-3' />
                                       ویرایش موقعیت
                                    </button>
                                </div>
                                :
                                <div className="col-12 my-3">
                                    <div className='alert alert-secondary p-3 text-small-2 fw-bold text-justify'>
                                        برای سهولت کارشناسان ما در هنگام مراجعه به محل شما بهتر است  محل آدرس خود بر روی نقشه را هم مشخص کنید.
                                        <div className='text-start'>
                                            <button className=' btn btn-warning text-small-1 fw-bold px-5 mt-3'
                                                    onClick={() => setHaveLocation(false)}

                                            >
                                                <TbBrandGoogleMaps className='ms-2 text-big-3' />
                                                تعیین آدرس روی نقشه
                                            </button>
                                        </div>

                                    </div>

                                </div>
                        }

                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="text"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="عنوان"
                                       value={title}
                                       onChange={(val) => {
                                           setTitle(val.target.value)
                                       }}
                                />
                                    <label htmlFor="floatingInput" className='text-small-2'>عنوان آدرس </label>
                            </div>
                        </div>
                        <div className="col-12 mt-3">
                            <div className="form-floating mb-3">
                                <input type="text"
                                       className="form-control"
                                       id="floatingInput"
                                       placeholder="تماس"
                                       value={phone}
                                       onChange={(val) => {
                                           setPhone(val.target.value)
                                       }}
                                />
                                    <label htmlFor="floatingInput" className='text-small-2'>شماره تماس </label>
                            </div>
                        </div>
                        <div className="col-12 my-3">
                            <button className='w-100 btn btn-success text-small-2 p-3'
                                    onClick={onSaveAddress}
                            >
                                ثبت آدرس
                            </button>
                        </div>

                    </div>
                </section>
            }
            <section className="container-fluid  mt-1 py-4 rtl px-0  ">
                <div className="row ">

                    <div className="col-12 max-w-lg">


                            <MapContainer
                                center={center}
                                zoom={zoom}
                                scrollWheelZoom={true}
                                className='max-w-lg'
                                ref={setMap}

                            >
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <Marker
                                    position={[position.lat.toFixed(4),position.lng.toFixed(4)]}
                                >
                                    <Popup>
                                        A pretty CSS3 popup. <br /> Easily customizable.
                                    </Popup>
                                </Marker>
                            </MapContainer>


                    </div>
                </div>
                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                        {
                            !haveLocation &&
                        <button
                            className="btn btn-warning text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={() => setHaveLocation(true)}
                        >
                            تایید موقعیت روی نقشه
                            <span className="badge  p-2 float-start">
<TbCheck className='text-big-3' />
                    </span>
                        </button> }
                    </div>
                </div>
            </section>


        </React.Fragment>
    );
}

export default AddAddress;